import { useTxUIWrapper } from "@src/context";
import { TxStatus } from "@src/models";
import { TxOverview } from "./TxOverview";
import { TxResult } from "./TxResult";

type Props = {
  onCloseClick: () => void;
};
export const ConfirmationView = ({ onCloseClick }: Props) => {
  const { txStatus, txError } = useTxUIWrapper();

  return txStatus === TxStatus.COMPLETED || txError ? (
    <TxResult onCloseClick={onCloseClick} />
  ) : (
    <TxOverview onCloseClick={onCloseClick} />
  );
};
